import TrafficSourceTypeMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSourceTypeMetric";

const sourceTypeMetrics = new Set(Object.values(TrafficSourceTypeMetric));

export const isTrafficSourceTypeMetric = (metric: string): metric is TrafficSourceTypeMetric => {
    return sourceTypeMetrics.has(metric as TrafficSourceTypeMetric);
};
